var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState } from "react";
import { useAppDispatch } from "module/main/store/hooks";
import { addErrorToast, addSuccessToast } from "module/main/store/toast/reducer";
import Modal from "module/common/components/Modal";
import useToggle from "module/common/hooks/useToggle";
import { formatErrorMessage } from "module/common/utils";
import IconTooltip from "./IconTooltip";
import { postRotateApiKey } from "module/main/store/auth/api";
import { setApiKeys } from "module/main/store/auth/reducer";
import { copyTextToClipboard } from "../utils";
import useInputType from "module/common/hooks/useInputType";
var CopyField = function (_a) {
    var inputProps = _a.inputProps, copyValue = _a.copyValue, InitialAddon = _a.InitialAddon;
    var dispatch = useAppDispatch();
    var _b = useInputType(), inputType = _b[0], changeApiKeyType = _b[1], inputValue = _b[2];
    var _c = useState(false), isCopied = _c[0], setIsCopied = _c[1];
    var _d = useToggle(), isRotateOpen = _d[0], toggleRotate = _d[2];
    var _e = useState(false), isRotating = _e[0], setIsRotating = _e[1];
    var onMouseLeave = function () { return setIsCopied(false); };
    var onCopy = function () {
        copyTextToClipboard(copyValue);
        setIsCopied(true);
    };
    var onRotate = function () {
        setIsRotating(true);
        toggleRotate();
        postRotateApiKey({ id: copyValue }) // CopyValue is also the UUID
            .then(function (_a) {
            var data = _a.data;
            dispatch(setApiKeys(data));
            dispatch(addSuccessToast("API key has been rotated"));
        })
            .catch(function (error) {
            var msg = formatErrorMessage(error);
            dispatch(addErrorToast(msg));
        })
            .finally(function () {
            setIsRotating(false);
        });
    };
    var rotateModal = useMemo(function () { return (_jsx(Modal, { isOpen: isRotateOpen, toggle: toggleRotate, title: "Rotate API Key", size: "md", buttons: [
            {
                name: "Nevermind",
                onClick: toggleRotate,
                className: "btn-secondary",
            },
            {
                name: "Rotate API Key",
                onClick: onRotate,
                className: "btn-primary",
                isLoading: isRotating,
            },
        ], children: _jsxs("div", { className: "p-3", children: [_jsx("p", { className: "mb-2", children: "Are you sure you want to rotate this API key?" }), _jsx("p", { className: "mb-4", children: "A new API key identifier will be generated for this key." }), _jsx("p", { className: "text-sm", children: "*Please note keys can only be rotated once a day" })] }) })); }, [isRotateOpen, isRotating, copyValue]);
    var tooltipText = isCopied ? "Copied!" : "Copy";
    var icon = inputType === "password" ? "eye" : "eye-slash";
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "input-group", onMouseLeave: onMouseLeave, children: [InitialAddon ? _jsx(_Fragment, { children: InitialAddon }) : null, _jsx("input", __assign({}, inputProps, { type: inputType })), _jsx(IconTooltip, { icon: ["far", "copy"], onClick: onCopy, color: "var(--primary)", children: tooltipText }), _jsx(IconTooltip, { className: "ml-2 ".concat(isRotating ? "animate-spin pointer-events-none" : ""), icon: ["fas", "rotate"], onClick: toggleRotate, color: "var(--primary)", children: "Rotate this API key" }), _jsx(IconTooltip, { icon: icon, onClick: function () { return changeApiKeyType(); }, color: "var(--primary)", className: "ml-2 transform cursor-pointer text-gray-500", children: inputValue })] }), rotateModal] }));
};
export default CopyField;
